<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="gift-start">
      <div
        class="review-container review-main text-capitalize position-relative container"
      >
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="chowman-pay-details plr15 d-flex justify-space-between">
              <h4 class="text-left">{{ $t("Chowman Pay History") }}</h4>
            </div>
            <div class="orders-tab-main plr15 mt-2">
              <div id="ongoing" class="tab-pane active tab-box">
                <div class="orders-lst skelton" v-if="is_skel_loader">
                  <a href="javascript:void(0);">
                    <div class="order-item d-flex align-items-start">
                      <div class="img-cls">
                        <skeleton-loader-vue
                          width="85px"
                          height="85px"
                          style="border-radius: 5px"
                        />
                      </div>
                      <div
                        class="order-data ml-3 d-flex align-items-start justify-content-between w-100"
                      >
                        <div class="orders-status-main delivery-link">
                          <h6 class="mb-1">
                            <skeleton-loader-vue
                              type="string"
                              width="130px"
                              height="20px"
                            />
                          </h6>
                          <skeleton-loader-vue
                            type="string"
                            width="50px"
                            height="20px"
                          />
                          <p class="mt-2">
                            <skeleton-loader-vue
                              type="string"
                              width="100px"
                              height="20px"
                            />
                          </p>
                        </div>
                        <div class="order-status">
                          <p class="order-status-btn">
                            <skeleton-loader-vue
                              type="circle"
                              width="100px"
                              height="20px"
                              style="border-radius: 20px !important"
                            />
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  class="orders-lst"
                  v-if="historyOrders.length > 0 && !is_skel_loader"
                >
                  <router-link
                    v-for="(order, index) in historyOrders"
                    :key="index"
                    :to="{
                      name: 'ChowmanPayOrderDetails',
                      params: { order_id: base64_encode(order.id) },
                    }"
                  >
                    <div
                      class="order-item d-flex align-items-start chowmna-pay"
                    >
                      <div class="img-cls resimg-squre">
                        <img
                          :src="order.icon_image"
                          @error="$event.target.src = noImge"
                        />
                      </div>
                      <div
                        class="order-data ml-3 d-flex align-items-start justify-content-between w-100"
                      >
                        <div
                          class="orders-status-main delivery-link on-going-order"
                        >
                          <h6 class="mb-1">{{ order.restaurant_name }}</h6>
                          <div
                            style="
                              display:block;
                            "
                          >
                            <h5
                              :style="{
                                color: 'red !important',
                                fontSize: '15px',
                                textTransform: 'none',
                              }"
                            >
                              {{ order.unique_code }}
                            </h5>
                            <p style="text-align:start">
                              {{
                                moment(order.created_at)
                                  .add(5, "hours")
                                  .add(30, "minutes")
                                  .format("DD-MM-YYYY h:mmA")
                              }}
                            </p>
                          </div>
                          <span
                            v-html="$auth.setting.currency"
                            class="currency"
                          ></span
                          ><span>{{ parseFloat(order.final_amount) }}</span>
                        </div>
                        <div
                          class="order-status"
                          v-if="order.payment_status == 'Completed'"
                        >
                          <p class="delivered order-status-btn">
                            {{ $t("Completed") }}
                          </p>
                        </div>
                        <div
                          class="order-status"
                          v-else-if="order.payment_status == 'Pending'"
                        >
                          <p class="readytoserve order-status-btn">
                            {{ $t("Pending") }}
                          </p>
                        </div>
                        <div
                          class="order-status"
                          v-else-if="order.payment_status == 'Failed'"
                        >
                          <p class="canceled order-status-btn">
                            {{ $t("Failed") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div v-else class="order-offers">
                  <p class="text-center ml-1">{{ $t("No History Found") }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VueSkeletonLoader from "skeleton-loader-vue";
import noImge from "@/assets/images/place_holder.png";
import NavBar from "@/components/NavBar.vue";
import Footer from "../components/Footer.vue";
import moment from "moment";

export default {
  components: { "skeleton-loader-vue": VueSkeletonLoader, NavBar, Footer },
  data() {
    return {
      moment: moment,
      historyOrders: [],
      is_skel_loader: true,
      skip: 0,
      isStopCallingApi: false,
      firstApiCall: true,
      noImge,
    };
  },
  mounted() {
    if (
      this.$auth.user &&
      this.$auth.setting.chowman_pay &&
      this.$auth.setting.chowman_pay == "active" &&
      this.$route.name == "chowman-pay-history"
    ) {
      window.addEventListener("scroll", () => {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
          if (!this.isStopCallingApi) {
            this.historyOrderLists();
            this.is_skel_loader = false;
          }
        }
      });
      if (this.firstApiCall) {
        this.historyOrderLists();
      }
    } else {
      this.$router.push({ name: "Home" });
    }
  },

  methods: {
    ...mapActions("order", ["getChowmanPayHistoryData"]),

    historyOrderLists() {
      this.is_skel_loader = true;
      if (this.$route.name == "chowman-pay-history") {
        this.getChowmanPayHistoryData({
          user_id: this.$auth.user.user_id,
          skip: this.skip,
          take: 20,
        }).then((data) => {
          this.firstApiCall = false;
          if (data.code == 200 && data.Result.length > 0) {
            this.is_skel_loader = false;
            this.skip = this.skip + 20;
            data.Result.forEach((element) => {
              this.historyOrders.push(element);
            });
            if (data.Result.length < 20) {
              this.isStopCallingApi = true;
            }
          } else {
            this.is_skel_loader = false;
            this.isStopCallingApi = true;
          }
        });
      }
    },
  },
};
</script>
